/** Percent-encoded control characters (%00–%1F, %7F): a link copied with its line break or tab. */
const ENCODED_CONTROL_CHARS = /%(?:[01][0-9a-f]|7f)/gi;

/**
 * Drops control characters from the page's path before the router reads it. React Router decodes
 * `/%0A` to "/\n" and Safari's URL parser then refuses the href it builds from it, which took the
 * whole app down into the ErrorBoundary (SHOP-WEB-50, `https://….online-karte.com/%0A`). No route
 * of ours has such a character, so the path is what the visitor meant without it.
 */
export function cleanLocationPath(win: Window = window): void {
  const { pathname, search, hash } = win.location;

  const stripped = pathname.replace(ENCODED_CONTROL_CHARS, '');

  if (stripped === pathname) {
    return;
  }

  // Collapsed, or "/%0A/" would leave "//", which replaceState reads as another host.
  const cleaned = stripped.replace(/\/{2,}/g, '/') || '/';

  win.history.replaceState(win.history.state, '', `${cleaned}${search}${hash}`);
}
